import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { MultiUnitPropertyDetailType, ResponseData } from "../common"

export interface MultiUnitsPropertyRequestData {
  propertyId: string
  multiUnitGroupId: string
  checkInDate: string
  checkOutDate: string
  numberOfGuest: number
  childrenCount: number
  adultCount: number
  petAllowed: boolean
  minBedRoom: number
  minBed?: number
  minBathRoom: number
  partyAllowed: boolean
  smokeAllowed: boolean
  suitableChild: boolean
  minPrice: number
  maxPrice: number
  featuresAndAmenities: string
  toggleOn: boolean
  page: number
  limit: number
  sortBy: string
  allInPriceToggle?: boolean
  isgoogle?: boolean
}

export interface MultiUnitsPropertyRequest extends Partial<AxiosRequestConfig> {
  params: MultiUnitsPropertyRequestData
}

export interface MultiUnitsPropertyResponseData extends ResponseData {
  data: MultiUnitPropertyDetailType
}

export interface MultiUnitsPropertyResponse extends AxiosResponse {
  data: MultiUnitsPropertyResponseData
}

export function getMultiUnitsPropertyDetailsApi(
  {
    params,
    method = "post",
    url = `/property/multi-units`,
    ...config
  }: MultiUnitsPropertyRequest,
  axiosInstance: AxiosInstance,
): Promise<MultiUnitsPropertyResponse> {
  return axiosInstance({
    data: params,
    method,
    url,
    ...config,
  }) as Promise<MultiUnitsPropertyResponse>
}
